import React from 'react';
import { FadeIn } from './FadeIn';
import { Check, X } from 'lucide-react';
export function WhoIsItFor() {
  const isFor = ['Padres que se sienten impotentes al ver a sus hijos adolescentes sufrir crisis de ansiedad.', 'Jóvenes de 16+ años que quieren manejar su propia ansiedad sin depender de nadie.', 'Familias que buscan una herramienta de auxilio rápido para tener en el celular en todo momento.', 'Personas que prefieren soluciones prácticas y directas por encima de teorías largas.'];
  const notFor = ['Personas que buscan un reemplazo a un tratamiento psiquiátrico para trastornos severos.', 'Quienes no están dispuestos a sentarse 5 minutos a practicar una técnica de respiración.', 'Casos de urgencia médica real que requieren atención hospitalaria inmediata.'];
  return <section className="w-full bg-white py-20 md:py-28 px-6" data-id="element-218">
      <div className="max-w-6xl mx-auto" data-id="element-219">
        <div className="grid md:grid-cols-2 gap-8 lg:gap-12" data-id="element-220">
          {/* Who it is for */}
          <FadeIn data-id="element-221">
            <div className="bg-sage-light rounded-3xl p-8 md:p-10 h-full border border-sage/30" data-id="element-222">
              <h2 className="text-2xl md:text-3xl font-serif text-slate-900 mb-8 border-b border-sage/30 pb-4" data-id="element-223">
                ¿Para Quién Es Esta Guía?
              </h2>
              <ul className="space-y-6" data-id="element-224">
                {isFor.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-225">
                    <div className="flex-shrink-0 mt-1 bg-sage/20 p-1 rounded-full" data-id="element-226">
                      <Check className="w-5 h-5 text-sage-dark stroke-[3]" data-id="element-227" />
                    </div>
                    <span className="text-slate-700 text-lg" data-id="element-228">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* Who it is NOT for */}
          <FadeIn delay={0.2} data-id="element-229">
            <div className="bg-slate-50 rounded-3xl p-8 md:p-10 h-full border border-slate-200" data-id="element-230">
              <h2 className="text-2xl md:text-3xl font-serif text-slate-500 mb-8 border-b border-slate-200 pb-4" data-id="element-231">
                ¿Para Quién NO Es?
              </h2>
              <ul className="space-y-6" data-id="element-232">
                {notFor.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-233">
                    <div className="flex-shrink-0 mt-1 bg-slate-200 p-1 rounded-full" data-id="element-234">
                      <X className="w-5 h-5 text-slate-500 stroke-[3]" data-id="element-235" />
                    </div>
                    <span className="text-slate-600 text-lg" data-id="element-236">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}